__turbopack_context__.v({
  "content": "tabs-module__JNGVta__content",
  "list": "tabs-module__JNGVta__list",
  "listPill": "tabs-module__JNGVta__listPill",
  "listUnderline": "tabs-module__JNGVta__listUnderline",
  "triggerPill": "tabs-module__JNGVta__triggerPill",
  "triggerUnderline": "tabs-module__JNGVta__triggerUnderline",
});
